.paymentModal {
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fffbf1;
  overscroll-behavior: none;

  &::before {
    content: '';
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 70%;
    max-height: 572px;
    display: block;
    z-index: -1;
    background-color: #fffbf1;
    max-width: 470px;
    width: 100%;
  }

  &:not(&_shown) * {
    pointer-events: none;
  }

  &_shown {
    opacity: 1;
    pointer-events: auto;
    z-index: 3;
  }
}

.paymentModal_Wrapper {
  margin: 0 auto;
  max-width: 470px;
  width: 100%;
  position: relative;
  color: black;
  background-color: #fffbf1;
  // transition: all 0.15s ease-out;
  // padding: 20px;
  // padding-top: 60px;
  padding-bottom: 30px;
  opacity: 0;
}

.paymentModal_header {
  width: 100%;
  height: 48px;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #ece5d8;
}

.paymentModal_headerLogo {
  width: 131px;
  height: 32px;
  min-width: 131px;
  min-height: 32px;
  display: block;
  background-image: url('./img/logo.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}

.paymentModal_headerLogoV2 {
  width: 205.45px;
  height: 26.45px;
  min-width: 205.45px;
  min-height: 26.45px;
  display: block;
  background-image: url('./img/logoV2.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}

.paymentModal_content {
  width: 100%;
  position: relative;
  padding: 0 20px;
}

.paymentModal_close {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  display: block;
  background-image: url('./img/close.png');
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: center center;
  position: absolute;
  top: -5px;
  right: 20px;
  cursor: pointer;

  &:active {
    opacity: 0.6;
  }
}

.paymentModal_title {
  margin-top: 13px;
  color: #231e19;
  text-align: center;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: -0.4px;
  padding: 0 40px;
}

.paymentModal_subtitle {
  margin-top: 10px;
  color: #231e19;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.045px;
}

.paymentModal_subtitleText1 {
  text-transform: capitalize;
}

.paymentModal_subtitleText2 {
  color: #00a370;
}

.paymentModal_subtitleText4 {
  text-transform: none;
}

.paymentModal_contentTextBlock {
  margin-top: 13px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.paymentModal_contentText1 {
  color: #231e19;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 19px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.4px;
}

.paymentModal_contentText2 {
  display: flex;
  align-items: center;
  color: #00a36f;
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 510;
  line-height: 16px;
  letter-spacing: -0.036px;

  span {
    margin-right: 1px;
    display: block;
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    background-image: url('./img/lock.png');
    background-size: 16px;
    background-repeat: no-repeat;
    background-position: center center;
  }
}

.paymentModal_guarantee {
  margin-top: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    margin-right: 2px;
    margin-bottom: 1px;
    display: flex;
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    justify-content: center;
    align-items: center;
    background-image: url('./img/shield.svg');
    background-size: 16px;
    background-repeat: no-repeat;
    background-position: center center;
  }

  p {
    color: #231e19;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.036px;
  }
}

.paymentModal_guarantee.grenn {
  p {
    color: #00a36f;
    text-align: center;
    font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
      sans-serif);
    font-size: 10px;
    font-style: normal;
    font-weight: 800;
    line-height: 14px;
    letter-spacing: 0.4px;
    text-transform: uppercase;
  }
}

:global .StripeElement--invalid {
  border: 1px solid #ff2d2d;
}

.paymentModal_shown {
  .paymentModal_Wrapper {
    animation: fadeIn both 0.4s 0.1s;
  }
}

:global {
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}

:global body.dark {
  :local {
    .paymentModal {
      &::before {
        background: #181716;
      }
    }

    .paymentModal_Wrapper {
      background: #181716;
    }

    .paymentModal_header {
      border-color: #2a2928;
    }

    .paymentModal_headerLogo {
      background-image: url('./img/logoDark.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center center;
    }

    .paymentModal_title,
    .paymentModal_subtitle,
    .paymentModal_contentText1,
    .paymentModal_guarantee p {
      color: #fffbf2;
    }
  }
}
